var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.432.174 9.25 8.866a1.043 1.043 0 0 1-.724 1.793H17.5v7.5c0 .92-.746 1.667-1.667 1.667h-3.85v-5.012a1 1 0 0 0-1-1H9.016a1 1 0 0 0-1 1V20h-3.85c-.92 0-1.666-.746-1.666-1.667v-7.5H1.042A1.043 1.043 0 0 1 .308 9.05L9.568.174a.625.625 0 0 1 .864 0",
    clipRule: "evenodd"
  })));
};
export default SvgHome;